// extracted by mini-css-extract-plugin
export var dividerLine = "_44-0";
export var errorBackground = "_44-1";